import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartQuery, CartService, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@fgb/portal-component-library/src/lib/pipes';
import * as ɵngcc4 from '@ngx-translate/core';

function CartItemComponent_ng_container_0_div_1_div_1_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelementStart(1, "span", 15);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attribute_r9 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", attribute_r9.AttributeName, ": ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attribute_r9.ValueName, " ");
} }
function CartItemComponent_ng_container_0_div_1_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵtemplate(1, CartItemComponent_ng_container_0_div_1_div_1_div_8_div_1_Template, 4, 2, "div", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", item_r5.attributes.LocalAttributes);
} }
function CartItemComponent_ng_container_0_div_1_div_1_div_9_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelementStart(1, "span", 15);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const customField_r12 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", customField_r12.customFieldName, ": ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", customField_r12.customFieldValue, " ");
} }
function CartItemComponent_ng_container_0_div_1_div_1_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, CartItemComponent_ng_container_0_div_1_div_1_div_9_div_1_div_1_Template, 4, 2, "div", 25);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const customField_r12 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", customField_r12.customFieldValue);
} }
function CartItemComponent_ng_container_0_div_1_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵtemplate(1, CartItemComponent_ng_container_0_div_1_div_1_div_9_div_1_Template, 2, 1, "div", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", item_r5.customFields);
} }
function CartItemComponent_ng_container_0_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelement(2, "img", 6);
    ɵngcc0.ɵɵpipe(3, "contentImage");
    ɵngcc0.ɵɵelementStart(4, "div", 7);
    ɵngcc0.ɵɵelementStart(5, "div", 8);
    ɵngcc0.ɵɵelementStart(6, "p", 9);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, CartItemComponent_ng_container_0_div_1_div_1_div_8_Template, 2, 1, "div", 10);
    ɵngcc0.ɵɵtemplate(9, CartItemComponent_ng_container_0_div_1_div_1_div_9_Template, 2, 1, "div", 11);
    ɵngcc0.ɵɵelementStart(10, "div", 12);
    ɵngcc0.ɵɵelementStart(11, "div", 13);
    ɵngcc0.ɵɵelementStart(12, "div", 14);
    ɵngcc0.ɵɵelementStart(13, "span", 15);
    ɵngcc0.ɵɵtext(14);
    ɵngcc0.ɵɵpipe(15, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 16);
    ɵngcc0.ɵɵelementStart(18, "span", 15);
    ɵngcc0.ɵɵtext(19);
    ɵngcc0.ɵɵpipe(20, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "div", 17);
    ɵngcc0.ɵɵelementStart(23, "button", 18);
    ɵngcc0.ɵɵlistener("click", function CartItemComponent_ng_container_0_div_1_div_1_Template_button_click_23_listener() { ɵngcc0.ɵɵrestoreView(_r17); const item_r5 = ctx.$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.remove(item_r5); });
    ɵngcc0.ɵɵpipe(24, "translate");
    ɵngcc0.ɵɵelement(25, "span", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(26, "hr", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("src", ɵngcc0.ɵɵpipeBind2(3, 9, item_r5.productData.ItemImageURL, "6"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r5.productData.DisplayName, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r5.attributes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r5.customFields);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(15, 12, "cart.quantity"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r5.purchaseQuantity, " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(20, 14, "cart.points"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r5.purchaseQuantity * item_r5.productData.PointValue, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(24, 16, "cart.remove.item.screenreader"));
} }
function CartItemComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtemplate(1, CartItemComponent_ng_container_0_div_1_div_1_Template, 27, 18, "div", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const items_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", items_r1);
} }
function CartItemComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 27);
    ɵngcc0.ɵɵelementStart(1, "p");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "cart.empty.basket"));
} }
function CartItemComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CartItemComponent_ng_container_0_div_1_Template, 2, 1, "div", 1);
    ɵngcc0.ɵɵtemplate(2, CartItemComponent_ng_container_0_div_2_Template, 4, 3, "div", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const items_r1 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", items_r1.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !items_r1.length);
} }
class CartItemComponent {
    constructor(cartQuery, cartService) {
        this.cartQuery = cartQuery;
        this.cartService = cartService;
    }
    ngOnInit() {
        this.items$ = this.cartQuery.selectAllMarketplaceCartData();
        this.totalItems$ = this.cartQuery.updateTotalItems();
        this.basketPointsTotal$ = this.cartQuery.updateBasketPointsTotal();
    }
    remove(itemToRemove) {
        this.cartService.remove(itemToRemove.id);
    }
}
CartItemComponent.ɵfac = function CartItemComponent_Factory(t) { return new (t || CartItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.CartQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.CartService)); };
CartItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CartItemComponent, selectors: [["fgbcl-cart-item"]], decls: 2, vars: 3, consts: [[4, "ngIf"], ["class", "ml-lg-3 column", 4, "ngIf"], ["class", "font-size-14", 4, "ngIf"], [1, "ml-lg-3", "column"], [4, "ngFor", "ngForOf"], [1, "d-flex", "flex-row", "mx-0"], ["alt", "", 1, "shadow", "rounded", 3, "src"], [1, "flex-column", "w-100", "ml-3"], [1, "d-flex", "flex-row", "text-left"], [1, "font-size-12", "mb-1"], ["class", "d-flex flex-row mb-1", 4, "ngIf"], ["class", "d-flex flex-row flex-wrap mb-1", 4, "ngIf"], [1, "d-flex", "flex-row", "justify-content-between"], [1, "d-flex", "flex-row", "w-100"], [1, "text-left", "font-size-12", "pl-0", "text-nowrap", "col-3"], [1, "font-weight-bold"], [1, "text-left", "font-size-12", "text-nowrap", "col-3"], [1, "text-right"], [1, "btn", "py-0", 3, "click"], [1, "icon", "icon-cancel-circle", "text-danger", "font-weight-bold"], [1, "border-disabled", "w-100", "mr-lg-2"], [1, "d-flex", "flex-row", "mb-1"], ["class", "text-left font-size-12 pl-0 text-nowrap mb-0 mr-4", 4, "ngFor", "ngForOf"], [1, "text-left", "font-size-12", "pl-0", "text-nowrap", "mb-0", "mr-4"], [1, "d-flex", "flex-row", "flex-wrap", "mb-1"], ["class", "text-left font-size-12 pl-0 mr-4 mb-0", 4, "ngIf"], [1, "text-left", "font-size-12", "pl-0", "mr-4", "mb-0"], [1, "font-size-14"]], template: function CartItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CartItemComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.items$));
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf], pipes: [ɵngcc2.AsyncPipe, ɵngcc3.ContentImagePipe, ɵngcc4.TranslatePipe], styles: ["img[_ngcontent-%COMP%]{width:50px;height:50px}"] });
CartItemComponent.ctorParameters = () => [
    { type: CartQuery },
    { type: CartService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CartItemComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-cart-item',
                template: "<ng-container *ngIf=\"items$ | async as items\">\r\n  <div *ngIf=\"items.length\" class=\"ml-lg-3 column\">\r\n    <div *ngFor=\"let item of items\">\r\n      <div class=\"d-flex flex-row mx-0\">\r\n        <img alt=\"\" class=\"shadow rounded\" src=\"{{ item.productData.ItemImageURL | contentImage: '6' }}\" />\r\n        <div class=\"flex-column w-100 ml-3\">\r\n          <div class=\"d-flex flex-row text-left\">\r\n            <p class=\"font-size-12 mb-1\">\r\n              {{ item.productData.DisplayName }}\r\n            </p>\r\n          </div>\r\n          <div *ngIf=\"item.attributes\" class=\"d-flex flex-row mb-1\">\r\n            <!-- For each selected attributes-->\r\n            <div\r\n              *ngFor=\"let attribute of item.attributes.LocalAttributes\"\r\n              class=\"text-left font-size-12 pl-0 text-nowrap mb-0 mr-4\"\r\n            >\r\n              <span class=\"font-weight-bold\">{{ attribute.AttributeName }}: </span> {{ attribute.ValueName }}\r\n            </div>\r\n          </div>\r\n          <div *ngIf=\"item.customFields\" class=\"d-flex flex-row flex-wrap mb-1\">\r\n            <!-- For each custom Field-->\r\n            <div *ngFor=\"let customField of item.customFields\">\r\n              <div *ngIf=\"customField.customFieldValue\" class=\"text-left font-size-12 pl-0 mr-4 mb-0\">\r\n                <span class=\"font-weight-bold\">{{ customField.customFieldName }}: </span> {{ customField.customFieldValue }}\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"d-flex flex-row justify-content-between\">\r\n            <div class=\"d-flex flex-row w-100\">\r\n              <div class=\"text-left font-size-12 pl-0 text-nowrap col-3\">\r\n                <span class=\"font-weight-bold\">{{ 'cart.quantity' | translate }} </span> {{ item.purchaseQuantity }}\r\n              </div>\r\n              <div class=\"text-left font-size-12 text-nowrap col-3\">\r\n                <span class=\"font-weight-bold\">{{ 'cart.points' | translate }} </span>\r\n                {{ item.purchaseQuantity * item.productData.PointValue }}\r\n              </div>\r\n            </div>\r\n            <div class=\"text-right\">\r\n              <button (click)=\"remove(item)\" class=\"btn py-0\" attr.aria-label=\"{{ 'cart.remove.item.screenreader' | translate }}\">\r\n                <span class=\"icon icon-cancel-circle text-danger font-weight-bold\"></span>\r\n              </button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <hr class=\"border-disabled w-100 mr-lg-2\" />\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"!items.length\" class=\"font-size-14\">\r\n    <p>{{ 'cart.empty.basket' | translate }}</p>\r\n  </div>\r\n</ng-container>\r\n",
                styles: ["img{width:50px;height:50px}"]
            }]
    }], function () { return [{ type: ɵngcc1.CartQuery }, { type: ɵngcc1.CartService }]; }, null); })();

class CartItemModule {
}
CartItemModule.ɵfac = function CartItemModule_Factory(t) { return new (t || CartItemModule)(); };
CartItemModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CartItemModule });
CartItemModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PipesModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CartItemModule, { declarations: function () { return [CartItemComponent]; }, imports: function () { return [CommonModule,
        PipesModule, ɵngcc4.TranslateModule]; }, exports: function () { return [CartItemComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CartItemModule, [{
        type: NgModule,
        args: [{
                declarations: [CartItemComponent],
                imports: [
                    CommonModule,
                    PipesModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [CartItemComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CartItemComponent, CartItemModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-cart-item.js.map